import { RouteUrl } from '@utils/routeUtil';

export interface IAnalyticsJFThreeLogRq {
  userId: string;
  previousPageUrl?: string | null;
  positionSn?: number;
  companySn?: number;
  positionName?: string;
  companyName?: string;
}

export default class AnalyticsJFThreeLogRq {
  userId: string;
  positionSn?: number;
  companySn?: number;
  positionName?: string;
  companyName?: string;
  idType: 'JOBDA' | 'KAKAO' | 'GOOGLE';
  isNewUser: boolean;

  constructor(vo: IAnalyticsJFThreeLogRq) {
    this.userId = vo.userId;
    this.positionSn = vo.positionSn;
    this.companySn = vo.companySn;
    this.positionName = vo.positionName;
    this.companyName = vo.companyName;

    this.idType = this.getIdType(vo.previousPageUrl);
    this.isNewUser = !!vo.previousPageUrl?.includes(RouteUrl.JOIN);
  }

  //이전 페이지에 따른 로그인 타입 return
  private getIdType(previousPageUrl?: string | null) {
    if (previousPageUrl?.includes('kakao')) {
      return 'KAKAO';
    } else if (previousPageUrl?.includes('google')) {
      return 'GOOGLE';
    } else {
      return 'JOBDA';
    }
  }
}
